export default __webpack_public_path__ + "static/media/paperOS_wordmark_white_lg.7f8950d3.png";